import { every, filter, first, get, keys, some } from "lodash";
import React, { useEffect, useState } from "react";
import useProductGroupsStorage from "resbutler-ui/hooks/useProductGroupsStorage";
import useProductsStorage from "resbutler-ui/hooks/useProductsStorage";
import { ProductCategoryId } from "resbutler-utils/types";
import { Restaurants } from "../../../resbutler-utils/types";
import { ProductSearchResult, ProductSize, ProductTypeId } from "../../../resbutler-utils/types/product";
import { Button, Modal, ModalBody, ModalFooter } from "../WizElements/Elements";
import { ProductSearch } from "./ProductSearch";

export interface ProductSearchModalProps {
  open?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  limitToOne?: boolean;
  onCloseData?: (data: ProductSearchResult[]) => void;
  productTypeIds?: ProductTypeId[];
  productCategoryIds?: ProductCategoryId[];
  initialValues?: ProductSearchResult[];
  where?: { field: string; value: any }[];
  productSizes?: ProductSize[];
  restaurantId?: string;
  limitToOneSize?: boolean;
  restaurants?: Restaurants;
}

export const ProductSearchModal: React.FC<ProductSearchModalProps> = ({ open, setOpen, limitToOne = false, onCloseData, where = [], productTypeIds = [], productCategoryIds = [], initialValues = [], productSizes, restaurantId, limitToOneSize, restaurants }) => {
  const [data, setData] = useState<ProductSearchResult[]>(initialValues);
  const [selectedRestaurantId, setSelectedRestaurantId] = useState(restaurantId);

  const [, productGroups] = useProductGroupsStorage();
  const [, products] = useProductsStorage();

  const productsByTypeId = filter(products, (p) => (!productTypeIds?.length || some(productTypeIds, (t) => p.typeId === t)) && (!productCategoryIds?.length || some(productCategoryIds, (c) => p.productCategoryId === c)));
  const productGroupsByCategoryId = filter(productGroups, (p) => !productCategoryIds?.length || some(productCategoryIds, (c) => p.productCategoryId === c));
  const productsByTypeIdsFiltered = filter(
    productsByTypeId,
    (p) => (!selectedRestaurantId || p.productCategoryId === ProductCategoryId.Inventory || p.productCategoryId === ProductCategoryId.GiftCertificates || p.restaurants?.[selectedRestaurantId]?.enabled) && (!where?.length || every(where, ({ field, value }) => get(p, field) === value))
  );

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      setData(initialValues);
    } else {
      document.body.style.overflow = "";
      setData([]);
    }
    return () => {
      document.body.style.overflow = "";
      setData([]);
    };
  }, [open]);

  useEffect(() => {
    if (!selectedRestaurantId && keys(restaurants).length > 0) {
      setSelectedRestaurantId(first(keys(restaurants)));
    }
  }, [selectedRestaurantId, restaurants]);

  const toggle = () => setOpen && setOpen(false);

  // if (keys(restaurants).length === 0) return <div>No Restaurants selected</div>;

  return (
    <Modal top isOpen={open} toggle={toggle} scrollable size="xl" className="search-for-products" zIndex={9999}>
      <div className="modal-header">
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="text-center fs-5">Search Products</div>
          <div className="pe-3">
            {keys(restaurants).length > 0 && (
              <select id="restaurant" className="form-select" value={selectedRestaurantId} disabled={!!restaurantId} onChange={(e) => setSelectedRestaurantId(e.target.value)}>
                {keys(restaurants).map((key) => (
                  <option key={key} value={key}>
                    {restaurants[key].name}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>
        <div className="head-right">
          <button type="button" className="btn-close" onClick={() => setOpen(false)} aria-label="Close"></button>
        </div>
      </div>
      <ModalBody>
        <ProductSearch sizes={productSizes} productGroups={productGroupsByCategoryId} products={productsByTypeIdsFiltered} data={data} limitToOne={limitToOne} limitToOneSize={limitToOneSize} restaurantId={selectedRestaurantId} onChange={(data) => setData(data)} />
      </ModalBody>
      <ModalFooter>
        <Button color="light" type="button" onClick={() => setOpen(false)}>
          Close
        </Button>
        <Button
          color="success"
          type="button"
          onClick={() => {
            onCloseData(data);
            setOpen(false);
          }}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};
